(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

require("core-js/fn/object/assign.js");

require("core-js/fn/array/find.js");

require("core-js/fn/array/find-index.js");

require("core-js/fn/array/fill.js");

require("core-js/fn/array/includes.js");

require("core-js/fn/array/from.js");

require("core-js/fn/symbol/index.js");

require("regenerator-runtime/runtime");

require("es6-promise/auto.js");

require("whatwg-fetch");

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _App = _interopRequireDefault(require("./components/App.jsx"));

var _topojson = _interopRequireDefault(require("topojson"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var mountNodes = document.querySelectorAll(".js-choropleth-mount");
var mountNode = mountNodes[0];
var mapDiv; // the states json and api urls and all it's parameters will be on the mount node

/* eg.  <div class="js-choropleth-mount"
            data-api-url="../data/fake-api.json"
            data-states-json="../data/states.json">
        </div>
*/
// let apiUrl        = "/assets/choropleth/data/fake-api-three.json";

var apiUrl = mountNode.getAttribute("data-api-url");
var statesJsonUrl = mountNode.getAttribute("data-states-json"); // convert the fetch response to JSON, or throw an error

function handleFetchResponse(response) {
  if (!response.ok) {
    throw new Error(response.statusText + ": " + response.url);
  }

  return response.json();
}

var fetchOptions = {
  method: "get",
  headers: {
    "Accept": "application/json; charset=utf-8" // only accept json (not xml)

  }
}; // load the data to draw the states, and get api data

Promise.all([fetch(statesJsonUrl, fetchOptions).then(handleFetchResponse), fetch(apiUrl, fetchOptions).then(handleFetchResponse)]).then(function (jsons) {
  var _jsons = _slicedToArray(jsons, 2),
      topoJsonData = _jsons[0],
      apiDataResponse = _jsons[1];

  var _loop = function _loop(i) {
    var apiData = apiDataResponse.mapToolResults[i]; // https://github.com/mbostock/topojson
    // transpile the TopoJSON data to GeoJSON data that d3 can understand

    var statesSvgData = _topojson.default.feature(topoJsonData, topoJsonData.objects.states);

    if (!apiData.states) {
      throw new Error("states data is empty!, check " + apiUrl);
    } // extract the U.S. data before we filter it


    var usData = apiData.states.find(function (s) {
      return s.name === "United States";
    });
    usData.abbreviation = "USA"; // DC might not be in the spreadsheet they upload

    var dcExists = false; // check the states and see if DC is there

    for (var j = 0; j < apiData.states.length; j++) {
      if (apiData.states[j].name === "District of Columbia") {
        dcExists = true;
        break;
      }
    } // if DC isn't there, let's add it and give it no data


    if (dcExists === false) {
      apiData.states.push({
        "name": "District of Columbia",
        "categories": []
      });
    } // the svg data has the state abbreviations, but the api data doesn't.
    // lets augment the api data with the abbreviations


    apiData.states = apiData.states.map(function (state) {
      var svgState = statesSvgData.features.find(function (f) {
        return f.properties.name === state.name;
      });

      if (svgState && svgState.properties) {
        state.abbreviation = svgState.properties.abbreviation;
      }

      return state;
    }) // filter out rows that don't have an associated shape in the svg.
    // (District of Columbia is in the svg, so it will be included)
    .filter(function (state) {
      return typeof state.abbreviation !== "undefined" && state.abbreviation !== "USA";
    });

    if (document.getElementById("map-" + i) == null) {
      mapDiv = document.createElement("div");
      mapDiv.id = "map-" + i;

      if (mountNodes[i] !== undefined) {
        mountNodes[i].appendChild(mapDiv);
      }

      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_App.default, {
        categories: apiData.categories,
        customText: apiData.customText,
        showTable: apiData.showTableButton,
        statesApiData: apiData.states,
        statesSvgData: statesSvgData,
        usData: usData,
        usFactoidColor: apiData.usFactoidColor
      }), mapDiv);
    }
  };

  for (var i = 0; i < apiDataResponse.mapToolResults.length; i++) {
    _loop(i);
  }
}).catch(function (error) {
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement("div", null, "There was an error loading the dataviz, make sure all map and legend data is populated in the content editor."), mountNode); // rethrow the error (source maps will still work)
  // http://stackoverflow.com/questions/30715367/why-can-i-not-throw-inside-a-promise-catch-handler


  setTimeout(function () {
    throw error;
  });
});

},{"./components/App.jsx":2,"core-js/fn/array/fill.js":"core-js/fn/array/fill.js","core-js/fn/array/find-index.js":"core-js/fn/array/find-index.js","core-js/fn/array/find.js":"core-js/fn/array/find.js","core-js/fn/array/from.js":"core-js/fn/array/from.js","core-js/fn/array/includes.js":"core-js/fn/array/includes.js","core-js/fn/object/assign.js":"core-js/fn/object/assign.js","core-js/fn/symbol/index.js":"core-js/fn/symbol/index.js","es6-promise/auto.js":"es6-promise/auto.js","react":"react","react-dom":"react-dom","regenerator-runtime/runtime":"regenerator-runtime/runtime","topojson":"topojson","whatwg-fetch":"whatwg-fetch"}],2:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _d3Scale = require("d3-scale");

var _debounce = _interopRequireDefault(require("../debounce.js"));

var _ChoroplethMap = _interopRequireDefault(require("./ChoroplethMap/ChoroplethMap.jsx"));

var _Legend = _interopRequireDefault(require("./Legend.jsx"));

var _RangeBar = _interopRequireDefault(require("./RangeBar.jsx"));

var _CategorySelector = _interopRequireDefault(require("./CategorySelector/CategorySelector.jsx"));

var _Table = _interopRequireDefault(require("./Table.jsx"));

var _CategorySelectDropdown = _interopRequireDefault(require("./CategorySelector/CategorySelectDropdown.jsx"));

var _StateSelectDropdown = _interopRequireDefault(require("./Mini/StateSelectDropdown.jsx"));

var _CategoryTable = _interopRequireDefault(require("./Mini/CategoryTable.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var locationShape = _react.PropTypes.shape({
  name: _react.PropTypes.string.isRequired,
  // uppercase, eg. Alabama, and with spaces, eg. "New Hampshire"
  abbreviation: _react.PropTypes.string.isRequired,
  categories: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    categoryId: _react.PropTypes.string.isRequired,
    html: _react.PropTypes.string.isRequired,
    color: _react.PropTypes.string,
    // null allowed
    value: _react.PropTypes.number,
    // null allowed
    label: _react.PropTypes.string
  })).isRequired
});

var _default = _react.default.createClass({
  displayName: "App",
  propTypes: {
    statesSvgData: _react.PropTypes.object.isRequired,
    categories: _react.PropTypes.array.isRequired,
    showTable: _react.PropTypes.oneOf(["none", "expanded", "collapsed"]),
    statesApiData: _react.PropTypes.arrayOf(locationShape).isRequired,
    usData: locationShape.isRequired,
    showDataPointInTooltip: _react.PropTypes.bool,
    usFactoidColor: _react.PropTypes.string,
    //optional
    customText: _react.PropTypes.object // optional

  },
  getDefaultProps: function getDefaultProps() {
    return {
      customText: {} // prevent null errors

    };
  },
  // Invoked once before the component is mounted. Return value is uses as initial this.state
  getInitialState: function getInitialState() {
    return {
      selectedCategoryId: this.props.categories[0].id,
      activeCategory: this.props.categories[0],
      activeLegend: this.props.categories[0].legend,
      hideDC: this.props.categories[0].hideDC,
      rangeBar: this.props.categories[0].rangeBar,
      activeState: "",
      // for popups/rangebar
      selectedStates: [],
      // for table on larger screens
      selectedStateMini: "",
      // for mini <CategoryTable>
      width: 0,
      shouldShowNoDataLegend: true,
      isTableNarrow: false
    };
  },
  componentWillMount: function componentWillMount() {
    // only compute this once
    this.stateOptions = this.props.statesApiData.map(function (s) {
      return {
        label: s.name,
        value: s.abbreviation
      };
    });
  },
  // Invoked once immediately after initial rendering
  componentDidMount: function componentDidMount() {
    this.debouncedResize = (0, _debounce.default)(this.onResize, 250);
    window.addEventListener("resize", this.debouncedResize); // trigger onResize() after it mounts so we can initialize the width of the app

    this.onResize();
  },
  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener("resize", this.debouncedResize);
  },
  // Runs every time the window is resized (window has an event listener) */
  onResize: function onResize() {
    // We can't use media queries, so we're grabbing the width of the app element instead
    this.setState({
      width: this.refs.app.clientWidth
    });
  },
  handleCategoryChange: function handleCategoryChange(categoryId) {
    this.setState({
      selectedCategoryId: categoryId,
      activeCategory: this.props.categories[categoryId],
      activeLegend: this.props.categories[categoryId].legend,
      hideDC: this.props.categories[categoryId].hideDC,
      rangeBar: this.props.categories[categoryId].rangeBar
    });
  },
  handleStateAdd: function handleStateAdd(abbreviation) {
    this.setState({
      selectedStates: this.state.selectedStates.concat(abbreviation)
    });
  },
  handleStateRemove: function handleStateRemove(abbreviation) {
    // remove the given abbreviation from the selectedStates
    this.setState({
      selectedStates: this.state.selectedStates.filter(function (ab) {
        return ab !== abbreviation;
      })
    });
  },
  handleClearAll: function handleClearAll() {
    this.setState({
      selectedStates: []
    });
  },
  handleAddAll: function handleAddAll() {
    this.setState({
      selectedStates: this.props.statesApiData.map(function (s) {
        return s.abbreviation;
      })
    });
  },
  // used for mini view of the data
  handleStateSelectDropdownChange: function handleStateSelectDropdownChange(abbreviation) {
    this.setState({
      selectedStateMini: abbreviation
    });
  },
  // Captures State.jsx click, passed up from state -> map -> here
  handleStateClick: function handleStateClick(abbreviation) {
    this.setState({
      activeState: abbreviation
    });
  },
  handleTableNarrowChange: function handleTableNarrowChange(isNarrow) {
    this.setState({
      isTableNarrow: isNarrow
    });
  },
  // area is a state abbreviation, or the us
  flattenCategoryData: function flattenCategoryData(area, selectedCategoryId, colorScale) {
    // flattened array of the data only for the selected category (for the map to consume)
    // we need a copy of the data so we don't overwrite the original with the delete statement below
    var stateCopy = JSON.parse(JSON.stringify(area)); // extract the category data for the selected category, and discard the rest afterward
    // keep all properties except categories

    var categoryData = stateCopy.categories.find(function (cat) {
      return cat.categoryId === selectedCategoryId;
    });
    delete stateCopy.categories;
    var stateColor = {}; // override color if there's a rangebar

    if (colorScale && categoryData) {
      var fill;

      if (typeof categoryData.value !== "number" && !categoryData.label) {
        fill = "url(#no-data-pattern)";
      } else {
        fill = colorScale(categoryData.value);
      }

      stateColor = {
        "color": fill
      };
    } // merge the extracted category data with the rest of the object


    return Object.assign(stateCopy, categoryData, stateColor);
  },
  // Uses this.props & this.state to build & return a single child element
  render: function render() {
    var _this = this;

    var _this$props$categorie = this.props.categories[this.state.selectedCategoryId],
        rangeBarMax = _this$props$categorie.rangeBarMax,
        rangeBarMaxColor = _this$props$categorie.rangeBarMaxColor,
        rangeBarMin = _this$props$categorie.rangeBarMin,
        rangeBarMinColor = _this$props$categorie.rangeBarMinColor,
        rangeBar = _this$props$categorie.rangeBar;
    var colorScale = rangeBar ? (0, _d3Scale.scaleLinear)().domain([rangeBarMin, rangeBarMax]).range([rangeBarMinColor, rangeBarMaxColor]) : null;
    var statesApiData = this.props.statesApiData.map(function (state) {
      return _this.flattenCategoryData(state, _this.state.selectedCategoryId, colorScale);
    });
    var activeStateApiData = statesApiData.find(function (state) {
      return state.abbreviation === _this.state.activeState;
    });
    var usData = this.flattenCategoryData(this.props.usData, this.state.selectedCategoryId);
    var selectedCategory = this.props.categories.find(function (category) {
      return category.id === _this.state.selectedCategoryId;
    }); // determine if we need to show the "No Data" legend
    // if any category in any state have a value of "null", we should show the No Data legend

    var shouldShowNoDataLegend = this.props.statesApiData.filter(function (state) {
      if (selectedCategory.hideDC && state.abbreviation === 'DC') {
        // If hiding DC and this state is DC, skip it regardless of any value
        return false;
      }

      return state.categories[selectedCategory.id] && state.categories[selectedCategory.id].value === null && !state.categories[selectedCategory.id].label;
    });
    shouldShowNoDataLegend = shouldShowNoDataLegend.length ? true : false;
    var activeLegend = selectedCategory.legend;
    var activeDataType = selectedCategory.dataType; // shared breakpoint classes

    var breakpoint = function () {
      if (_this.state.width <= 590) {
        return "is-small";
      } // make sure the state boxes still have room to show [DC]


      if (_this.state.width <= 780) {
        return "is-medium";
      }

      if (_this.state.width > 780) {
        return "is-large";
      }
    }(); // if we should show the small screen stuff


    var isSmallScreen = breakpoint === "is-small";
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "choropleth-app",
      ref: "app"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "choropleth-header__title"
    }, this.props.customText.titleText), /*#__PURE__*/_react.default.createElement(_CategorySelector.default, {
      categories: this.props.categories,
      onCategoryChange: this.handleCategoryChange,
      selectedCategoryId: this.state.selectedCategoryId,
      onWidthChange: this.handleCategorySelectTabsWidthChange,
      width: this.state.width
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "choropleth-header__subtitle"
    }, // mini or full text
    isSmallScreen ? this.props.customText.titleHelperMiniText || "" : this.props.customText.titleHelperText || ""), /*#__PURE__*/_react.default.createElement(_ChoroplethMap.default, {
      selectedCategory: selectedCategory,
      shouldShowBoxes: !isSmallScreen,
      isInteractive: !isSmallScreen,
      statesSvgData: this.props.statesSvgData,
      selectedStates: this.state.selectedStates,
      statesApiData: statesApiData,
      hideDC: this.state.hideDC,
      usData: usData,
      usFactoidColor: this.props.usFactoidColor,
      width: this.state.width,
      canAddStates: this.props.showTable !== "none",
      onStateAdd: this.handleStateAdd,
      showDataPointInTooltip: this.props.showDataPointInTooltip,
      onStateClick: this.handleStateClick
    }), // IIFE to figure out whether to show legend boxes or range bar
    function () {
      if (_this.state.rangeBar !== true) {
        return /*#__PURE__*/_react.default.createElement(_Legend.default, {
          legends: activeLegend,
          breakpoint: breakpoint,
          showNoData: shouldShowNoDataLegend
        });
      } else {
        return /*#__PURE__*/_react.default.createElement(_RangeBar.default, {
          legends: activeLegend,
          category: selectedCategory,
          breakpoint: breakpoint,
          showNoData: shouldShowNoDataLegend,
          selectedCategoryId: _this.state.selectedCategoryId,
          stateData: activeStateApiData
        });
      }
    }(), // IIFE to figure out if/what table we should display
    function () {
      // if we shouldn't show the table, abort
      if (_this.props.showTable === "none") {
        return;
      } // show all the "mini" stuff on small screens


      if (isSmallScreen) {
        // get the category values for the selected state in mini view
        var stateCategoryValues = null;

        var selectedState = _this.props.statesApiData.find(function (state) {
          return state.abbreviation === _this.state.selectedStateMini;
        });

        if (selectedState && selectedState.categories) {
          stateCategoryValues = selectedState.categories.map(function (category) {
            return {
              categoryId: category.categoryId,
              label: category.label,
              value: category.value
            };
          });
        }

        return /*#__PURE__*/_react.default.createElement("div", {
          className: "mini-data"
        }, /*#__PURE__*/_react.default.createElement(_StateSelectDropdown.default, {
          states: _this.stateOptions,
          onChange: _this.handleStateSelectDropdownChange,
          value: _this.state.selectedStateMini,
          selectText: _this.props.customText.stateDropdownMessage
        }), /*#__PURE__*/_react.default.createElement(_CategoryTable.default, {
          categories: _this.props.categories,
          values: stateCategoryValues,
          helperText: _this.props.customText.stateSelectionHelpText
        }));
      } // otherwise, show the full table if it's a medium or large screen
      else {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "large-data"
        }, // only show the dropdown if it's a medium screen and if there is more than 1 category
        _this.state.isTableNarrow && _this.props.categories.length > 1 ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
          className: "category-dropdown-helper-text"
        }, _this.props.customText.categoryHelperText || "Select category to view state data"), /*#__PURE__*/_react.default.createElement(_CategorySelectDropdown.default, {
          categories: _this.props.categories,
          onCategoryChange: _this.handleCategoryChange,
          value: _this.state.selectedCategoryId
        })) : null, /*#__PURE__*/_react.default.createElement(_Table.default, {
          selectedCategoryId: _this.state.selectedCategoryId,
          categories: _this.props.categories,
          onNarrowChange: _this.handleTableNarrowChange,
          statesApiData: _this.props.statesApiData,
          selectedStates: _this.state.selectedStates,
          onStateRemove: _this.handleStateRemove,
          onClearAll: _this.handleClearAll,
          onAddAll: _this.handleAddAll,
          dataType: activeDataType,
          startCollapsed: _this.props.showTable === "collapsed",
          customText: _this.props.customText
        }));
      }
    }()
    /* IIFE */
    );
  }
});

exports.default = _default;

},{"../debounce.js":17,"./CategorySelector/CategorySelectDropdown.jsx":4,"./CategorySelector/CategorySelector.jsx":6,"./ChoroplethMap/ChoroplethMap.jsx":8,"./Legend.jsx":11,"./Mini/CategoryTable.jsx":12,"./Mini/StateSelectDropdown.jsx":13,"./RangeBar.jsx":14,"./Table.jsx":15,"classnames":"classnames","d3-scale":"d3-scale","react":"react"}],3:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = _react.default.createClass({
  displayName: "Button",
  propTypes: {
    children: _react.PropTypes.node,
    onClick: _react.PropTypes.func.isRequired,
    isDisabled: _react.PropTypes.bool,
    className: _react.PropTypes.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      isDisabled: false
    };
  },
  handleClick: function handleClick(e) {
    if (!this.props.isDisabled) {
      this.props.onClick(e);
    }
  },
  render: function render() {
    var btnClasses = (0, _classnames.default)("choropleth-btn", this.props.className, {
      "choropleth-btn--disabled": this.props.isDisabled
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: btnClasses,
      onClick: this.handleClick
    }, this.props.children);
  }
});

exports.default = _default;

},{"classnames":"classnames","react":"react"}],4:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = _react.default.createClass({
  displayName: "CategorySelectDropdown",
  propTypes: {
    categories: _react.PropTypes.arrayOf(_react.PropTypes.shape({
      id: _react.PropTypes.string,
      label: _react.PropTypes.string
    })).isRequired,
    onCategoryChange: _react.PropTypes.func.isRequired,
    selectedCategoryId: _react.PropTypes.string.isRequired
  },
  handleDropdownChange: function handleDropdownChange(value) {
    this.props.onCategoryChange(value);
  },
  render: function render() {
    var categoryOptions = this.props.categories.map(function (obj) {
      return {
        label: obj.label,
        value: obj.id
      };
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "category-dropdown"
    }, /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
      name: "category-dropdown",
      value: this.props.selectedCategoryId,
      options: categoryOptions,
      onChange: this.handleDropdownChange,
      clearable: false,
      backspaceRemoves: false
    }));
  }
});

exports.default = _default;

},{"react":"react","react-select":"react-select"}],5:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = _react.default.createClass({
  displayName: "CategorySelectTabs",
  propTypes: {
    categories: _react.PropTypes.arrayOf(_react.PropTypes.shape({
      id: _react.PropTypes.string.isRequired,
      label: _react.PropTypes.string.isRequired
    })).isRequired,
    onCategoryChange: _react.PropTypes.func.isRequired,
    selectedCategoryId: _react.PropTypes.string.isRequired
  },
  handleCategoryClick: function handleCategoryClick(category) {
    this.props.onCategoryChange(category);
  },
  // to be called by the parent
  getCatTitleWidth: function getCatTitleWidth() {
    var categoryTitles = this.refs["cat-sel"].querySelectorAll('.category-selector__item');
    var titleWidth = 0;

    for (var i = 0; i < categoryTitles.length; i++) {
      titleWidth = titleWidth + categoryTitles[i].clientWidth;
    }

    var width = titleWidth + 10;
    return width;
  },
  render: function render() {
    var _this = this;

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "category-selector",
      ref: "cat-sel"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "category-selector__items"
    }, this.props.categories.map(function (category, i) {
      var itemClasses = (0, _classnames.default)("category-selector__item", {
        "category-selector__item--selected": _this.props.selectedCategoryId === category.id
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        key: category.id,
        className: itemClasses,
        onClick: _this.handleCategoryClick.bind(_this, category.id)
      }, category.label);
    })));
  }
});

exports.default = _default;

},{"classnames":"classnames","react":"react"}],6:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CategorySelectDropdown = _interopRequireDefault(require("./CategorySelectDropdown.jsx"));

var _CategorySelectTabs = _interopRequireDefault(require("./CategorySelectTabs.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = _react.default.createClass({
  displayName: "CategorySelector",
  propTypes: {
    categories: _react.PropTypes.arrayOf(_react.PropTypes.shape({
      id: _react.PropTypes.string.isRequired,
      label: _react.PropTypes.string.isRequired
    })).isRequired,
    onCategoryChange: _react.PropTypes.func.isRequired,
    selectedCategoryId: _react.PropTypes.string.isRequired,
    width: _react.PropTypes.number.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      categoryElement: "tabs"
    };
  },
  componentDidMount: function componentDidMount() {
    // measure again after the page is loaded, the fonts might have changed and made this wider/narrower
    window.addEventListener("load", this.handleWidthChange);
    this.handleWidthChange(); // make sure we resize when we first mount
  },
  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener("load", this.handleWidthChange);
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    // if the width changed, re-measure the tabs
    if (this.props.width !== prevProps.width) {
      this.handleWidthChange();
    }
  },
  handleWidthChange: function handleWidthChange() {
    var _this = this;

    // reset to always show the tabs so we can measure
    this.setState({
      categoryElement: "tabs"
    }, function () {
      // abort if we don't have the tabs ref
      if (!_this.refs["tabs"]) {
        return;
      } // now that the tabs are rendered, we can measure them


      var tabsWidth = _this.refs["tabs"].getCatTitleWidth(); // figure out which element to show
      // (if the tabs fit, show those)


      var categoryElement = _this.props.categories.length <= 1 ? "none" : tabsWidth < _this.props.width ? "tabs" : "dropdown";

      _this.setState({
        categoryElement: categoryElement,
        tabsWidth: tabsWidth
      });
    });
  },
  render: function render() {
    var _this2 = this;

    var categoryElement = this.state.categoryElement;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "category-selector-container"
    }, // show the small or large category selector
    function () {
      // don't show anything if there is only 1 category
      if (categoryElement === "none") {
        return null;
      } // if the category selector is too wide
      else if (categoryElement === "dropdown") {
        return /*#__PURE__*/_react.default.createElement(_CategorySelectDropdown.default, {
          categories: _this2.props.categories,
          onCategoryChange: _this2.props.onCategoryChange,
          selectedCategoryId: _this2.props.selectedCategoryId
        });
      } // on large screens
      else if (categoryElement === "tabs") {
        return /*#__PURE__*/_react.default.createElement(_CategorySelectTabs.default, {
          ref: "tabs",
          categories: _this2.props.categories,
          onCategoryChange: _this2.props.onCategoryChange,
          selectedCategoryId: _this2.props.selectedCategoryId,
          onWidthChange: _this2.handleTabWidthChange
        });
      }
    }());
  }
});

exports.default = _default;

},{"./CategorySelectDropdown.jsx":4,"./CategorySelectTabs.jsx":5,"classnames":"classnames","react":"react"}],7:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _polished = require("polished");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var boxDimensions = {
  width: 40,
  height: 22,
  spacing: 5
};

var _default = _react.default.createClass({
  displayName: "Box",
  propTypes: {
    onBoxHover: _react.PropTypes.func.isRequired,
    onBoxClick: _react.PropTypes.func.isRequired,
    isInteractive: _react.PropTypes.bool,
    top: _react.PropTypes.number.isRequired,
    text: _react.PropTypes.string.isRequired,
    isHovered: _react.PropTypes.bool.isRequired,
    color: _react.PropTypes.string // null allowed

  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    // only re-render if the hovered state is changed.
    return this.props.isHovered !== nextProps.isHovered || this.props.color !== nextProps.color;
  },
  handleBoxClick: function handleBoxClick(e) {
    // prevent other actions from happening (eg, window click away)
    e.stopPropagation(); // call parent function

    this.props.onBoxClick();
  },
  render: function render() {
    var _this$props = this.props,
        onBoxHover = _this$props.onBoxHover,
        top = _this$props.top,
        text = _this$props.text,
        isInteractive = _this$props.isInteractive,
        isHovered = _this$props.isHovered,
        color = _this$props.color;
    var classBoxName = "state-box__background";
    var classTextName = "state-box__label";
    var pointerStyle = isInteractive ? "pointer" : "default";

    if (color === undefined) {
      classBoxName += " hidden";
      classTextName += " hidden";
    } // state color or "no data fill" if the color is null


    var fillColor = color || "url(#no-data-pattern)";
    var fontColor = fillColor === "url(#no-data-pattern)" || (0, _polished.getLuminance)(fillColor) > 0.5 ? "black" : "white";
    return /*#__PURE__*/_react.default.createElement("g", {
      transform: "translate(0, ".concat(top, ")"),
      onMouseEnter: onBoxHover,
      onClick: this.handleBoxClick
    }, /*#__PURE__*/_react.default.createElement("rect", {
      className: classBoxName,
      width: boxDimensions.width,
      height: boxDimensions.height,
      opacity: isHovered ? 0.75 : 1,
      fill: fillColor,
      stroke: isHovered ? "white" : "transparent",
      strokeWidth: isHovered ? "3" : "1",
      style: {
        "cursor": pointerStyle,
        "transition": "fill 0.25s"
      }
    }), /*#__PURE__*/_react.default.createElement("text", {
      className: classTextName,
      x: boxDimensions.width / 2,
      y: boxDimensions.height / 2 + 4 // + 4 nudging to adjust for height of text
      ,
      style: {
        "fill": fontColor,
        "textAnchor": "middle",
        "fontSize": "12px",
        "cursor": pointerStyle
      }
    }, text));
  }
});

exports.default = _default;

},{"polished":"polished","react":"react"}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classnames = _interopRequireDefault(require("classnames"));

var _d3Geo = require("d3-geo");

var _d3Selection = require("d3-selection");

var _topojson = _interopRequireDefault(require("topojson"));

var _State = _interopRequireDefault(require("./State.jsx"));

var _Box = _interopRequireDefault(require("./Box.jsx"));

var _Popup = _interopRequireDefault(require("./Popup.jsx"));

var _debounce = _interopRequireDefault(require("../../debounce.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react.default.PropTypes,
    string = _React$PropTypes.string,
    number = _React$PropTypes.number,
    object = _React$PropTypes.object,
    bool = _React$PropTypes.bool,
    array = _React$PropTypes.array,
    func = _React$PropTypes.func,
    arrayOf = _React$PropTypes.arrayOf,
    shape = _React$PropTypes.shape,
    oneOf = _React$PropTypes.oneOf,
    oneOfType = _React$PropTypes.oneOfType;
var boxStates = ["VT", "NH", "MA", "RI", "CT", "NJ", "DE", "MD", "DC"];
var dataShape = shape({
  name: string.isRequired,
  // uppercase, eg. Alabama, and with spaces, eg. "New Hampshire"
  abbreviation: string.isRequired,
  html: string,
  color: string,
  // null allowed
  value: number,
  // null allowed
  label: string
});

var _default = _react.default.createClass({
  displayName: "ChoroplethMap",
  propTypes: {
    selectedCategory: shape({
      dataType: oneOf(["string", "number"]).isRequired,
      usFactoidColor: string,
      // if there is no rangebar, this value comes as "NaN".
      // TODO redesign the API for the legend/rangebar
      rangeBarMin: oneOfType([number, string]),
      rangeBarMax: oneOfType([number, string]),
      rangeBar: bool,
      showDataPointInTooltip: bool
    }),
    width: number.isRequired,
    selectedStates: array.isRequired,
    hideDC: bool.isRequired,
    shouldShowBoxes: bool.isRequired,
    isInteractive: bool.isRequired,
    statesApiData: arrayOf(dataShape).isRequired,
    usData: dataShape.isRequired,
    usFactoidColor: string,
    // optional
    // a d3 FeatureCollection https://github.com/mbostock/topojson/wiki/API-Reference#feature
    statesSvgData: object.isRequired,
    canAddStates: bool.isRequired,
    // if there is no table, the popup shouldn't show the add button
    onStateAdd: func.isRequired,
    onStateClick: func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      hoveredState: "",
      // two letter abbreviation of the state that is currently being hovered
      selectedState: "",
      // two letter abbreviation of the state that is currently selected
      height: 0,
      path: (0, _d3Geo.geoPath)(),
      // function to draw state paths, will change when the size changes
      toolTip: {
        show: false,
        top: 0,
        left: 0
      }
    };
  },
  componentWillMount: function componentWillMount() {
    this.handleWidthChange(this.props.width); // http://stackoverflow.com/questions/23123138/perform-debounce-in-react-js

    this.handleMapMouseMoveDebounced = (0, _debounce.default)(function (event) {
      // don't do anything if the map is not interactive, or if they user isn't currently
      // hovering over the map somewhere, or if there is a popup
      var isInteractive = this.props.isInteractive;
      var isOverInteractiveState = this.state.hoveredState !== "" && this.getStateData(this.state.hoveredState).isInteractive;
      var noSelection = this.state.selectedState === "";

      if (isInteractive && isOverInteractiveState && noSelection) {
        // show the tool-tip
        this.setState({
          toolTip: {
            show: true,
            // using position fixed
            // http://stackoverflow.com/questions/9262741/what-is-the-difference-between-pagex-y-clientx-y-screenx-y-in-javascript
            top: event.clientY,
            left: event.clientX
          }
        });
      }
    }, 500);
  },
  // remove all listener on unmount
  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("keyup", this.handleKeyUp, true);
    window.removeEventListener("click", this.handleClickAway, true);
  },
  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
    if (newProps.width !== this.props.width) {
      this.handleWidthChange(newProps.width);
    }
  },
  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
    // if the tool tip is going to show, attach scroll listener to dismiss it
    if (nextState.toolTip.show) {
      window.addEventListener("scroll", this.handleScroll);
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    // bring the hovered state to the front
    var hoveredState = this.refs["state" + this.state.hoveredState];

    if (hoveredState) {
      var node = _reactDom.default.findDOMNode(hoveredState);

      node.parentNode.appendChild(node); // http://bl.ocks.org/eesur/4e0a69d57d3bfc8a82c2
    }
  },
  // given a width, calculate the height and the d3 path function to draw the states.
  handleWidthChange: function handleWidthChange(width) {
    // make sure the new width is a number (otherwise, it throws a ton of svg errors...)
    if (typeof width !== "number") {
      return;
    } // calculate height based on the width


    var heightRatio = .62;
    var height = width * heightRatio; // recalculate the path function when the width/height changes

    var projection = (0, _d3Geo.geoAlbersUsa)().scale(width * 1.3) // magic number to make the us full width...
    .translate([width / 2, height / 2]);
    this.setState({
      height: height,
      path: (0, _d3Geo.geoPath)().projection(projection),
      hoveredState: "" // make sure we clear the hovered state

    });
  },
  handleStateHover: function handleStateHover(abbreviation, stateInteractive) {
    // abort if this map is not interactive, or if the hovered state is the same
    if (!this.props.isInteractive || this.state.hoveredState === abbreviation || !stateInteractive) {
      return;
    }

    this.setState({
      hoveredState: abbreviation
    });
  },
  handleStateClick: function handleStateClick(abbreviation) {
    var _this = this;

    var stateApiData = this.getStateData(abbreviation); // abort if this map is not interactive, or if the user clicked the same state again

    if (!this.props.isInteractive || this.state.selectedState === abbreviation || !stateApiData.isInteractive) {
      return;
    } // update the state and add click away listener to window
    // addEventListener will not add it twice


    var newState = {
      selectedState: abbreviation,
      toolTip: {
        show: false
      } // hide the tooltip if they've clicked

    }; //  Passes state click up from state -> map -> app

    this.props.onStateClick(abbreviation);
    this.setState(newState, function () {
      window.addEventListener("click", _this.handleClickAway, true);
    });
  },
  handleScroll: function handleScroll(e) {
    // hide the tool tip if the user scrolls at all
    if (this.state.toolTip.show) {
      this.setState({
        toolTip: {
          show: false
        }
      });
    } // we're done with this now, detach


    window.removeEventListener("scroll", this.handleScroll);
  },
  // added as window event listener after a state is selected
  handleClickAway: function handleClickAway(e) {
    // only clear the selectedState if they're actually clicking away
    // ie. not on another state, or a state popup, or a category selector item
    var shouldClear = !hasParentWithClass(e.target, ".state-popup") && !hasParentWithClass(e.target, ".state") && !hasParentWithClass(e.target, ".category-selector__item"); // clear the selected state and remove event listener from the window

    if (shouldClear) {
      this.deselectState();
    }
  },
  handleKeyUp: function handleKeyUp(e) {
    var charCode = e.which ? e.which : e.keyCode; // if esc is pressed, clear the popups.

    if (charCode === 27) {
      this.deselectState();
    }
  },
  deselectState: function deselectState() {
    this.setState({
      selectedState: ""
    });
    this.props.onStateClick(null);
    window.removeEventListener("click", this.handleClickAway, true);
  },
  handleAddClick: function handleAddClick(abbreviation) {
    this.props.onStateAdd(abbreviation);
  },
  handleMapMouseMove: function handleMapMouseMove(e) {
    // http://stackoverflow.com/questions/23123138/perform-debounce-in-react-js
    e.persist(); // * HACK for internet explorer 11
    // IE fires mousemove even when the mouse doesn't move.  If the user is in the same spot,
    // ignore it.

    if (e.clientX === this.mouseMoveX && e.clientY === this.mouseMoveY) {
      return;
    }

    this.mouseMoveX = e.clientX;
    this.mouseMoveY = e.clientY; // end * HACK
    // hide the tool tip if the mouse moves at all

    if (this.state.toolTip.show) {
      this.setState({
        toolTip: {
          show: false
        }
      });
    }

    this.handleMapMouseMoveDebounced(e);
  },
  getStateData: function getStateData(abbreviation) {
    var _this2 = this;

    var dataType = this.props.selectedCategory.dataType;
    var stateApiData = this.props.statesApiData.find(function (s) {
      return s.abbreviation === abbreviation;
    }); // if a value is null, empty string or undefined

    var isEmpty = function isEmpty(v) {
      return v === null || v === "" || typeof v === "undefined";
    }; // determine if this state should be clickable


    var isInteractive = function isInteractive() {
      // value will always be null for "string" dateTypes, check the label instead
      var valueToCheck = dataType === "string" ? stateApiData.label : stateApiData.value; // if that value and the html is empty, no click for you!

      if (isEmpty(valueToCheck) && isEmpty(stateApiData.html)) {
        return false;
      } // otherwise, use the global setting


      return _this2.props.isInteractive;
    };

    return Object.assign({}, stateApiData, {
      isInteractive: isInteractive()
    });
  },
  render: function render() {
    var _this3 = this;

    var boxDimensions = {
      width: 40,
      height: 22,
      top: this.state.height * (37 / 100),
      left: this.props.width - 50,
      spacing: 5
    }; // if there is a popup, add a listener for esc

    if (this.state.selectedState !== "") {
      window.addEventListener("keyup", this.handleKeyUp, true);
    } else {
      window.removeEventListener("keyup", this.handleKeyUp, true);
    } // if there is a color provided, use it


    var usFactoidStyles = {
      color: this.props.selectedCategory.usFactoidColor || this.props.usData.color || null
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "choropleth-map",
      ref: "choropleth"
    }, /*#__PURE__*/_react.default.createElement("svg", {
      className: "choropleth-map-svg",
      width: this.props.width,
      height: this.state.height,
      style: {
        "margin": "auto",
        "display": "block"
      },
      onMouseMove: this.handleMapMouseMove
    }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("pattern", {
      id: "no-data-pattern",
      patternUnits: "userSpaceOnUse",
      width: "7px",
      height: "7px"
    }, /*#__PURE__*/_react.default.createElement("path", {
      stroke: "#b3b3b3",
      d: "M-1,1 l2,-2\r M0,7  l7,-7\r M6,8  l2,-2"
    }))), /*#__PURE__*/_react.default.createElement("g", {
      className: "states",
      onMouseLeave: this.handleStateHover.bind(this, "")
    }, this.props.statesSvgData.features.map(function (state) {
      // get the api data for this state (color, value, etc)
      var stateApiData = _this3.getStateData(state.properties.abbreviation);

      var isBoxState = typeof boxStates.find(function (bs) {
        return bs === state.properties.abbreviation;
      }) === "undefined";
      return /*#__PURE__*/_react.default.createElement(_State.default, {
        stateValue: stateApiData.value,
        ref: "state" + state.properties.abbreviation,
        key: state.properties.abbreviation,
        isInteractive: stateApiData.isInteractive,
        isHovered: state.properties.abbreviation === _this3.state.hoveredState,
        onStateHover: _this3.handleStateHover.bind(_this3, state.properties.abbreviation, stateApiData.isInteractive),
        onStateClick: _this3.handleStateClick.bind(_this3, state.properties.abbreviation),
        path: _this3.state.path,
        stateFeature: state,
        color: stateApiData.color,
        shouldDisplayLabel: isBoxState,
        labelSize: _this3.props.width > 550 ? 12 : 10
      });
    })), // show the state boxes only if we're told to
    this.props.shouldShowBoxes ? /*#__PURE__*/_react.default.createElement("g", {
      className: "state-boxes",
      onMouseLeave: this.handleStateHover.bind(this, ""),
      transform: "translate(".concat(boxDimensions.left, ", ").concat(boxDimensions.top, ")")
    }, boxStates.map(function (bs, i) {
      // get the api data for this state (color, value, etc)
      // Assigns `isInteractive` to states
      var stateApiData = _this3.getStateData(bs);

      if (_this3.props.hideDC === true && bs === "DC") {
        return false;
      }

      return /*#__PURE__*/_react.default.createElement(_Box.default, {
        key: bs,
        isHovered: bs === _this3.state.hoveredState,
        onBoxHover: _this3.handleStateHover.bind(_this3, bs, stateApiData.isInteractive),
        onBoxClick: _this3.handleStateClick.bind(_this3, bs, stateApiData),
        isInteractive: stateApiData.isInteractive,
        text: bs,
        top: i * (boxDimensions.height + boxDimensions.spacing),
        color: stateApiData.color
      });
    })) : null), /*#__PURE__*/_react.default.createElement("div", {
      className: "us-factoid",
      dangerouslySetInnerHTML: {
        __html: this.props.usData.html
      },
      style: usFactoidStyles
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "state-popups"
    }, this.props.statesApiData.map(function (stateData) {
      var stateFeature = _this3.props.statesSvgData.features.find(function (svg) {
        return svg.properties.abbreviation === stateData.abbreviation;
      });

      return /*#__PURE__*/_react.default.createElement(_Popup.default, {
        key: stateData.name,
        stateData: stateData,
        showData: _this3.props.selectedCategory.showDataPointInTooltip,
        path: _this3.state.path,
        stateFeature: stateFeature,
        showAdd: _this3.props.canAddStates,
        canAdd: _this3.props.selectedStates.indexOf(stateData.abbreviation) === -1,
        isHidden: stateData.abbreviation !== _this3.state.selectedState,
        onAddClick: _this3.handleAddClick.bind(_this3, stateData.abbreviation),
        onXClick: _this3.deselectState
      });
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "tool-tip",
      ref: "tool-tip",
      style: {
        display: this.state.toolTip.show ? "block" : "none",
        top: this.state.toolTip.top,
        left: this.state.toolTip.left
      }
    }, "Click to view data"));
  }
}); // returns true if the element or one of its parents has the class classname


exports.default = _default;

function hasParentWithClass(element, className) {
  // return false if we've reached the top of the tree.
  // (html.parentNode is #document, so we need to explicitly check for html)
  if (element && element.tagName.toLowerCase() === "html") {
    return false;
  } // using d3 to select the element because document.querySelector(".state").parentNode.className returns
  // an SVGAnimatedString for some reason...
  // if this element has that classname, return true
  // remove the leading . if it's there


  if ((0, _d3Selection.select)(element).classed(className.replace(".", ""))) {
    return true;
  } // recurse with the parentNode


  return hasParentWithClass(element.parentNode, className);
}

},{"../../debounce.js":17,"./Box.jsx":7,"./Popup.jsx":9,"./State.jsx":10,"classnames":"classnames","d3-geo":"d3-geo","d3-selection":"d3-selection","react":"react","react-dom":"react-dom","topojson":"topojson"}],9:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("../Button.jsx"));

var _XIcon = _interopRequireDefault(require("../XIcon.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ABBREVIATION_OFFSET = 10;

var _default = _react.default.createClass({
  displayName: "Popup",
  propTypes: {
    isHidden: _react.PropTypes.bool,
    stateData: _react.PropTypes.shape({
      name: _react.PropTypes.string.isRequired,
      // uppercase, eg. Alabama, and with spaces, eg. "New Hampshire"
      abbreviation: _react.PropTypes.string.isRequired,
      html: _react.PropTypes.string,
      color: _react.PropTypes.string,
      // null allowed
      value: _react.PropTypes.number,
      // null allowed
      label: _react.PropTypes.string
    }).isRequired,
    stateFeature: _react.PropTypes.object.isRequired,
    // for calculating centroid
    path: _react.PropTypes.func.isRequired,
    // d3 path function https://github.com/mbostock/d3/wiki/Geo-Paths
    onAddClick: _react.PropTypes.func.isRequired,
    onXClick: _react.PropTypes.func.isRequired,
    canAdd: _react.PropTypes.bool.isRequired,
    // if this state is already added, disable the add button
    showAdd: _react.PropTypes.bool.isRequired,
    // whether or not to hide the add button completely
    showData: _react.PropTypes.bool.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      isHidden: true
    };
  },
  getInitialState: function getInitialState() {
    var d3Calculations = this.getExpensiveD3Calculations(this.props.path, this.props.stateFeature);
    return {
      width: 0,
      // measured from the DOM
      height: 0,
      parentWidth: 0,
      parentHeight: 0,
      position: d3Calculations.position,
      realLeft: d3Calculations.position.left,
      // value used as "left" for the popup
      realTop: d3Calculations.position.top,
      triangleHeight: 10,
      // used to calculate the top value
      // amount that this popup is outside of it's parent. positive numbers means outside, negative numbers are inside.
      overflow: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }
    };
  },
  componentDidMount: function componentDidMount() {
    this.calculatePositions();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextState) {
    // these functions are expensive, only recalculate it if we need to
    if (this.props.path !== nextProps.path) {
      this.setState(this.getExpensiveD3Calculations(nextProps.path, nextProps.stateFeature));
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    // only update if the props or state have changed
    return JSON.stringify(nextProps) !== JSON.stringify(this.props) || JSON.stringify(nextState) !== JSON.stringify(this.state);
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    var positionHasChanged = prevState.position.left !== this.state.position.left || prevState.position.top !== this.state.position.top;
    var contentChanged = prevProps.stateData.html !== this.props.stateData.html || prevProps.stateData.value !== this.props.stateData.value; // only calculate new positions if the position or content (width/height) has changed.

    if (positionHasChanged || contentChanged) {
      this.calculatePositions();
    }
  },
  getExpensiveD3Calculations: function getExpensiveD3Calculations(path, stateFeature) {
    var centroid = path.centroid(stateFeature); // these functions are expensive, cache them in the state

    return {
      position: {
        left: centroid[0],
        top: centroid[1]
      }
    };
  },
  // if this popup is outside of it's parent, nudge it back in
  calculatePositions: function calculatePositions() {
    // get the width and height of this popup from the DOM
    var $popup = this.refs.popup;
    var width = $popup.offsetWidth;
    var height = $popup.offsetHeight; // get the width/height of the parent container div

    var $parent = $popup.parentNode;
    var parentWidth = $parent.offsetWidth;
    var parentHeight = $parent.offsetHeight; // if the parent size is smaller than this, something is wrong, abort

    if (parentHeight < height || parentWidth < width) {
      return;
    } // point DC at exactly where it is on the map, offset all others for the size of the abbreviation text offset


    var offsetY = this.props.stateData.abbreviation === "DC" ? 0 : ABBREVIATION_OFFSET; // measure the popup bubble triangle

    var triangleHeight = this.refs.triangle.offsetHeight; // calculate where the top of the popup should be based on this.props.position

    var realTop = this.state.position.top - height - triangleHeight - offsetY;
    var realLeft = this.state.position.left - width / 2; // center
    // the amounts that this popup is outside of it's parent.

    var overflow = {
      top: -realTop,
      right: -(parentWidth - (realLeft + width)),
      bottom: height - (parentHeight - this.state.position.top - triangleHeight - offsetY),
      left: -realLeft
    }; // update the state with all the measurements

    this.setState({
      realTop: realTop,
      realLeft: realLeft,
      width: width,
      height: height,
      parentWidth: parentWidth,
      parentHeight: parentHeight,
      overflow: overflow,
      triangleHeight: triangleHeight
    });
  },
  handleAddClick: function handleAddClick(e) {
    e.preventDefault();
    this.props.onAddClick();
  },
  handleXClick: function handleXClick(e) {
    e.preventDefault();
    this.props.onXClick();
  },
  render: function render() {
    // boolean if the popup overflows out the top of the parent
    var overflowBottom = this.state.overflow.bottom > 0;
    var popupClasses = (0, _classnames.default)("state-popup", {
      "state-popup--hidden": this.props.isHidden,
      "is-triangle-bottom": overflowBottom,
      "is-triangle-top": !overflowBottom
    }); // start with popupLeft as what was calculated as the realLeft of the popup

    var popupTop = this.state.position.top + this.state.triangleHeight + ABBREVIATION_OFFSET;
    var popupLeft = this.state.realLeft;
    var triangleLeft = 0; // if there is an overflow on the right, adjust the popup and triangle position

    if (this.state.overflow.right > 0) {
      popupLeft = this.state.realLeft - this.state.overflow.right;
      triangleLeft = this.state.overflow.right;
    } // if there is an overflow on the left, adjust the popup and triangle position


    if (this.state.overflow.left > 0) {
      popupLeft = this.state.realLeft + this.state.overflow.left;
      triangleLeft = -this.state.overflow.left;
    } // if there is an overflow above, show the popup below the state


    if (overflowBottom) {
      popupTop = this.state.realTop;
    }

    var popupStyles = {
      "position": "absolute",
      "top": popupTop,
      "left": popupLeft
    }; // center the triangle and nudge if needed

    var triangleStyles = {
      left: "calc(50% + ".concat(triangleLeft, "px)")
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: popupClasses,
      style: popupStyles,
      ref: "popup"
    }, /*#__PURE__*/_react.default.createElement(_XIcon.default, {
      stroke: "#999",
      onClick: this.handleXClick,
      className: "state-popup__x-icon"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "state-popup__name"
    }, this.props.stateData.name), // if there is html in the state data, add it
    this.props.stateData.label && this.props.showData ? /*#__PURE__*/_react.default.createElement("div", {
      className: "state-popup__value"
    }, this.props.stateData.label) : null, // if there is html in the state data, add it
    this.props.stateData.html ? /*#__PURE__*/_react.default.createElement("div", {
      className: "state-popup__html",
      dangerouslySetInnerHTML: {
        __html: this.props.stateData.html
      }
    }) : null, // show/hide the add button
    this.props.showAdd ? /*#__PURE__*/_react.default.createElement("div", {
      className: "state-popup__add-state"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: this.handleAddClick,
      isDisabled: !this.props.canAdd
    }, this.props.canAdd ? "Add state to table" : "State added")) : null, /*#__PURE__*/_react.default.createElement("div", {
      className: "state-popup__triangle",
      ref: "triangle",
      style: triangleStyles
    }));
  }
});

exports.default = _default;

},{"../Button.jsx":3,"../XIcon.jsx":16,"classnames":"classnames","react":"react"}],10:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _polished = require("polished");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = _react.default.createClass({
  displayName: "State",
  propTypes: {
    // static props
    stateValue: _react.PropTypes.number,
    stateFeature: _react.PropTypes.object.isRequired,
    // for svg drawing
    onStateHover: _react.PropTypes.func.isRequired,
    onStateClick: _react.PropTypes.func.isRequired,
    shouldDisplayLabel: _react.PropTypes.bool.isRequired,
    labelSize: _react.PropTypes.number,
    // props that will change (see shouldComponentUpdate)
    isInteractive: _react.PropTypes.bool.isRequired,
    isHovered: _react.PropTypes.bool.isRequired,
    path: _react.PropTypes.func.isRequired,
    // d3 path function https://github.com/mbostock/d3/wiki/Geo-Paths
    color: _react.PropTypes.string // null allowed

  },
  getDefaultProps: function getDefaultProps() {
    return {
      labelSize: 12
    };
  },
  getInitialState: function getInitialState() {
    // we're using state as a cache of expensive functions
    return Object.assign({}, this.getExpensiveD3Calculations(this.props.path, this.props.stateFeature));
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextState) {
    // these functions are expensive, only recalculate it if we need to
    if (this.props.path !== nextProps.path) {
      this.setState(this.getExpensiveD3Calculations(nextProps.path, nextProps.stateFeature));
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    // NOTE: onStateHover and onStateClick change everytime because it's being passed a bound
    // function from ChoroplthMap everytime (this.handleStateClick.bind(this, state.properties.abbreviation))
    // only rerender this state if one of these have changed.  The other props are static.
    // this is for performace, we don't want to rerender this state if nothing has actually changed
    return this.props.isHovered !== nextProps.isHovered || this.props.path !== nextProps.path || this.props.isInteractive !== nextProps.isInteractive || this.props.color !== nextProps.color;
  },
  getExpensiveD3Calculations: function getExpensiveD3Calculations(path, stateFeature) {
    // these functions are expensive, cache them in the state
    return {
      centroid: path.centroid(stateFeature),
      pathD: path(stateFeature)
    };
  },
  handleStateClick: function handleStateClick(e) {
    // prevent other actions from happening (eg, window click away)
    e.stopPropagation(); // call parent function

    this.props.onStateClick();
  },
  render: function render() {
    var _this$props = this.props,
        stateFeature = _this$props.stateFeature,
        isHovered = _this$props.isHovered,
        shouldDisplayLabel = _this$props.shouldDisplayLabel,
        onStateClick = _this$props.onStateClick,
        onStateHover = _this$props.onStateHover,
        color = _this$props.color,
        stateValue = _this$props.stateValue; // state color or "no data fill" if the color is null

    var fillColor = color || "url(#no-data-pattern)"; // black if the fill color is "no data" or if fill color is light

    var fontColor = !fillColor || fillColor === "url(#no-data-pattern)" || (0, _polished.getLuminance)(fillColor) > 0.5 ? "black" : "white"; // HI gets special treatment because it's label isn't on the state background

    if (stateFeature.properties.abbreviation === "HI") {
      fontColor = "black";
    }

    return /*#__PURE__*/_react.default.createElement("g", {
      className: "state",
      onMouseEnter: onStateHover,
      onClick: this.handleStateClick
    }, /*#__PURE__*/_react.default.createElement("path", {
      className: "state__path",
      d: this.state.pathD,
      fill: fillColor,
      stroke: isHovered ? "white" : "white",
      opacity: isHovered ? 0.75 : 1,
      strokeWidth: isHovered ? "3" : "1",
      style: {
        "cursor": this.props.isInteractive ? "pointer" : "default",
        "transition": "fill 0.25s"
      }
    }), /*#__PURE__*/_react.default.createElement("text", {
      className: "state__label",
      x: this.state.centroid[0],
      y: this.state.centroid[1],
      dx: stateFeature.properties.dx || 0,
      dy: stateFeature.properties.dy || 0,
      style: {
        "display": shouldDisplayLabel ? "block" : "none",
        "fill": fontColor,
        "fontSize": this.props.labelSize,
        "textAnchor": "middle",
        "dominantBaseline": "middle",
        "cursor": this.props.isInteractive ? "pointer" : "default"
      }
    }, stateFeature.properties.abbreviation));
  }
});

exports.default = _default;

},{"polished":"polished","react":"react"}],11:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = _react.default.createClass({
  displayName: "Legend",
  propTypes: {
    legends: _react.PropTypes.arrayOf(_react.PropTypes.shape({
      label: _react.PropTypes.string.isRequired,
      color: _react.PropTypes.string.isRequired
    })).isRequired,
    width: _react.PropTypes.number,
    // optional
    breakpoint: _react.PropTypes.oneOf(["is-large", "is-medium", "is-small"]),
    showNoData: _react.PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      width: 0,
      breakpoint: "is-small",
      showNoData: true
    };
  },
  // Invoked once before the component is mounted. Return value is uses as initial this.state
  getInitialState: function getInitialState() {
    return {
      labelWidth: "auto"
    };
  },
  componentDidMount: function componentDidMount() {
    // needs to be on componentDidMount instead of componentWillMount so this.refs is available
    // initialize some stuff
    this.handleWidthChange(this.props);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    // reset the labelWidth in preparation for componentDidUpdate
    if (this.shouldRecalulateLabelWidths(nextProps)) {
      this.setState({
        labelWidth: "auto"
      });
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    // the labelWidth should be reset by componentWillReceiveProps, recalculate it
    if (this.shouldRecalulateLabelWidths(prevProps)) {
      this.handleWidthChange(this.props);
    }
  },
  shouldRecalulateLabelWidths: function shouldRecalulateLabelWidths(nextOrPrevProps) {
    // if the legend text or breakpoint has changed
    return this.props.legends !== nextOrPrevProps.legends || this.props.breakpoint !== nextOrPrevProps.breakpoint;
  },
  // make all the labels the same width so they wrap at the same time
  handleWidthChange: function handleWidthChange(_ref) {
    var _this = this;

    var legends = _ref.legends;
    // get the width of the widest label using the no data label as the starting comparison
    // (or 0 if the "no data" label isn't there)
    var startingWidth = this.props.showNoData ? this.refs.noDataLabel.clientWidth : 0;
    var labelWidth = legends.reduce(function (widestLabel, current, i) {
      return _this.refs["label".concat(i)].clientWidth > widestLabel ? _this.refs["label".concat(i)].clientWidth : widestLabel;
    }, startingWidth); // update the state

    this.setState({
      labelWidth: labelWidth
    });
  },
  render: function render() {
    var _this2 = this;

    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)("legend", this.props.breakpoint),
      ref: "legend"
    }, this.props.legends.map(function (legend, i) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: i,
        className: "legend__item"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "legend__box"
      }, /*#__PURE__*/_react.default.createElement("svg", {
        width: "100%",
        height: "100%"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        fill: legend.color
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "legend__label",
        ref: "label".concat(i),
        style: {
          width: _this2.state.labelWidth
        }
      }, legend.label));
    }), // show the "No Data" legend if the props say to
    this.props.showNoData ? /*#__PURE__*/_react.default.createElement("div", {
      className: "legend__item"
    }, /*#__PURE__*/_react.default.createElement("svg", {
      className: "legend__box legend__box--no-data"
    }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("pattern", {
      id: "no-data-pattern",
      patternUnits: "userSpaceOnUse",
      width: "7px",
      height: "7px"
    }, /*#__PURE__*/_react.default.createElement("path", {
      stroke: "#b3b3b3",
      d: "M-1,1 l2,-2 M0,7  l7,-7 M6,8  l2,-2"
    }))), /*#__PURE__*/_react.default.createElement("rect", {
      className: "legend__box",
      fill: "url(#no-data-pattern)",
      height: "30",
      width: "30"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "legend__label",
      ref: "noDataLabel",
      style: {
        width: this.state.labelWidth
      }
    }, "No data")) : null);
  }
});

exports.default = _default;

},{"classnames":"classnames","react":"react"}],12:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var noData = /*#__PURE__*/_react.default.createElement("span", {
  className: "no-data"
}, "No data");

var _default = _react.default.createClass({
  displayName: "CategoryTable",
  propTypes: {
    categories: _react.PropTypes.arrayOf(_react.PropTypes.shape({
      id: _react.PropTypes.string.isRequired,
      label: _react.PropTypes.string.isRequired
    })).isRequired,
    values: _react.PropTypes.arrayOf(_react.PropTypes.shape({
      categoryId: _react.PropTypes.string.isRequired,
      label: _react.PropTypes.string.isRequired,
      value: _react.PropTypes.any
    })),
    // can be null
    onCategoryClick: _react.PropTypes.func,
    // not required
    helperText: _react.PropTypes.string // optional

  },
  render: function render() {
    var _this = this;

    var tableClasses = (0, _classnames.default)("category-table", {
      "category-table--empty": !this.props.values
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: tableClasses
    }, this.props.categories.map(function (category, i) {
      var value = "";

      if (_this.props.values) {
        var v = _this.props.values.find(function (v) {
          return v.categoryId === category.id;
        });

        value = v ? v.label || noData : noData; // get label or use - to indicate no data
      } // if we have no data, show this default message on the first row
      else if (i === 0) {
        value = _this.props.helperText || "Select a state to view data";
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "category-table__row",
        key: category.id
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "category-table__category-label",
        onClick: _this.handleCategoryClick
      }, category.label), /*#__PURE__*/_react.default.createElement("div", {
        className: "category-table__category-value"
      }, value));
    }));
  }
});

exports.default = _default;

},{"classnames":"classnames","react":"react"}],13:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactSelect = _interopRequireDefault(require("react-select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = _react.default.createClass({
  displayName: "StateSelectDropdown",
  propTypes: {
    states: _react.PropTypes.array.isRequired,
    value: _react.PropTypes.string.isRequired,
    // can be empty string
    onChange: _react.PropTypes.func.isRequired,
    selectText: _react.PropTypes.string // optional

  },
  render: function render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "states-dropdown"
    }, /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
      name: "states-dropdown",
      value: this.props.value,
      options: this.props.states,
      onChange: this.props.onChange,
      clearable: true,
      backspaceRemoves: false,
      placeholder: this.props.selectText || "Select a State"
    }));
  }
});

exports.default = _default;

},{"classnames":"classnames","react":"react","react-select":"react-select"}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react.default.PropTypes,
    arrayOf = _React$PropTypes.arrayOf,
    oneOf = _React$PropTypes.oneOf,
    shape = _React$PropTypes.shape,
    string = _React$PropTypes.string,
    bool = _React$PropTypes.bool,
    object = _React$PropTypes.object,
    number = _React$PropTypes.number,
    array = _React$PropTypes.array;

var _default = _react.default.createClass({
  displayName: "RangeBar",
  propTypes: {
    legends: arrayOf(shape({
      label: string.isRequired,
      color: string.isRequired
    })).isRequired,
    category: shape({
      dataType: string.isRequired,
      hideDC: bool.isRequired,
      id: string.isRequired,
      label: string.isRequired,
      legend: array.isRequired,
      rangeBar: bool.isRequired,
      rangeBarMax: number.isRequired,
      rangeBarMaxColor: string.isRequired,
      rangeBarMaxLabel: string,
      rangeBarMin: number.isRequired,
      rangeBarMinColor: string.isRequired,
      rangeBarMinLabel: string,
      showDataPointInTooltip: bool.isRequired,
      themeColor: string.isRequired,
      usFactoidColor: string.isRequired
    }).isRequired,
    selectedCategoryId: string.isRequired,
    showNoData: bool,
    displayStateValue: bool,
    breakpoint: oneOf(["is-small", "is-medium", "is-large"]),
    // optional
    stateData: shape({
      color: string.isRequired,
      label: string.isRequired,
      value: number // could be null if the state has no data

    })
  },
  getDefaultProps: function getDefaultProps() {
    return {
      breakpoint: "is-large"
    };
  },
  // Invoked once before the component is mounted. Return value is uses as initial this.state
  getInitialState: function getInitialState() {
    return {};
  },
  render: function render() {
    var stateData = this.props.stateData;
    var currentStateValue = stateData ? stateData.value : 0; // for rangeBarMinColor, extract it, or use default

    var _this$props$category = this.props.category,
        rangeBarMax = _this$props$category.rangeBarMax,
        rangeBarMin = _this$props$category.rangeBarMin,
        _this$props$category$ = _this$props$category.rangeBarMaxColor,
        rangeBarMaxColor = _this$props$category$ === void 0 ? "#000" : _this$props$category$,
        _this$props$category$2 = _this$props$category.rangeBarMinColor,
        rangeBarMinColor = _this$props$category$2 === void 0 ? "#fff" : _this$props$category$2,
        rangeBarMaxLabel = _this$props$category.rangeBarMaxLabel,
        rangeBarMinLabel = _this$props$category.rangeBarMinLabel; // Defines the left offset percentage for properly positioning selected state value label

    var currentStatePercentage = function currentStatePercentage() {
      // use this (instead of currentStateValue) if you don't want value outside of the rangebar to leave the rangebar
      // const constrainedValue = Math.min(
      //     rangeBarMax,
      //     Math.max(currentStateValue, rangeBarMin)
      // );
      return Math.round((currentStateValue - rangeBarMin) / (rangeBarMax - rangeBarMin) * 100) + '%';
    }; // check to see if the value is there
    // https://github.com/ramda/ramda/blob/v0.22.1/src/isNil.js
    // != null will cover null and undefined


    var hasValue = typeof stateData !== "undefined" && stateData.value != null;
    var rangeBarValueStyles = {
      "display": hasValue ? "block" : "none",
      // a value is required to show this
      "marginLeft": currentStatePercentage(),
      "color": stateData ? stateData.color : "#000"
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)("range-bar", this.props.breakpoint)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "range-bar__container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "range-bar__low"
    }, rangeBarMinLabel), /*#__PURE__*/_react.default.createElement("div", {
      className: "range-bar__bar"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "range-bar__value",
      style: rangeBarValueStyles
    }, stateData && stateData.label), /*#__PURE__*/_react.default.createElement("svg", {
      width: "100%",
      height: "20",
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
      id: "range-bar__gradient"
    }, /*#__PURE__*/_react.default.createElement("stop", {
      offset: "0%",
      stopColor: rangeBarMinColor
    }), /*#__PURE__*/_react.default.createElement("stop", {
      offset: "100%",
      stopColor: rangeBarMaxColor
    }))), /*#__PURE__*/_react.default.createElement("rect", {
      fill: "url(#range-bar__gradient)",
      x: "0",
      y: "0",
      width: "100%",
      height: "100%"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "range-bar__high"
    }, rangeBarMaxLabel)), // show the "No Data" legend if the props say to
    this.props.showNoData ? /*#__PURE__*/_react.default.createElement("div", {
      className: "legend__item"
    }, /*#__PURE__*/_react.default.createElement("svg", {
      className: "legend__box legend__box--no-data"
    }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("pattern", {
      id: "no-data-pattern",
      patternUnits: "userSpaceOnUse",
      width: "7px",
      height: "7px"
    }, /*#__PURE__*/_react.default.createElement("path", {
      stroke: "#b3b3b3",
      d: "M-1,1 l2,-2 M0,7  l7,-7 M6,8  l2,-2"
    }))), /*#__PURE__*/_react.default.createElement("rect", {
      className: "legend__box",
      fill: "url(#no-data-pattern)",
      height: "30",
      width: "30"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "legend__label",
      ref: "noDataLabel",
      style: {
        width: this.state.labelWidth
      }
    }, "No data")) : null);
  }
});

exports.default = _default;

},{"classnames":"classnames","react":"react"}],15:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("./Button.jsx"));

var _XIcon = _interopRequireDefault(require("./XIcon.jsx"));

var _debounce = _interopRequireDefault(require("../debounce.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = _react.default.createClass({
  displayName: "Table",
  propTypes: {
    dataType: _react.PropTypes.oneOf(["number", "string"]).isRequired,
    // used for sort
    statesApiData: _react.PropTypes.arrayOf(_react.PropTypes.shape({
      name: _react.PropTypes.string.isRequired,
      // uppercase, eg. Alabama, and with spaces, eg. "New Hampshire"
      abbreviation: _react.PropTypes.string.isRequired,
      categories: _react.PropTypes.arrayOf(_react.PropTypes.shape({
        categoryId: _react.PropTypes.string.isRequired,
        color: _react.PropTypes.string,
        // null allowed
        value: _react.PropTypes.number,
        // null allowed
        label: _react.PropTypes.string
      }))
    })).isRequired,
    categories: _react.PropTypes.arrayOf(_react.PropTypes.shape({
      id: _react.PropTypes.string.isRequired,
      label: _react.PropTypes.string.isRequired
    })).isRequired,
    selectedCategoryId: _react.PropTypes.string.isRequired,
    // empty string is all categories
    selectedStates: _react.PropTypes.arrayOf(_react.PropTypes.string),
    // abbreviations
    onStateRemove: _react.PropTypes.func.isRequired,
    onClearAll: _react.PropTypes.func.isRequired,
    onAddAll: _react.PropTypes.func.isRequired,
    onNarrowChange: _react.PropTypes.func.isRequired,
    // a function called when state.isNarrow changes
    startCollapsed: _react.PropTypes.bool,
    customText: _react.PropTypes.shape({
      // optional
      "tableShowText": _react.PropTypes.string,
      "tableHideText": _react.PropTypes.string,
      "tableClearAllText": _react.PropTypes.string,
      "tableAddAllText": _react.PropTypes.string,
      "tableEmptyDefaultText": _react.PropTypes.string
    })
  },
  getDefaultProps: function getDefaultProps() {
    return {
      customText: {} // prevent null errors

    };
  },
  getInitialState: function getInitialState() {
    // PCT-5919: if all categories are "hideDC", and there is no values for DC, hide it
    var dc = this.props.statesApiData.find(function (s) {
      return s.abbreviation === "DC";
    });
    var dcDataIsEmpty = dc && dc.categories.length === 0;
    var hideDcForAllCategories = this.props.categories.every(function (c) {
      return c.hideDC;
    });
    var hideDc = hideDcForAllCategories && dcDataIsEmpty;
    return {
      sortColumnId: "name",
      sortDirection: "asc",
      // default sort direction
      isCollapsed: this.props.startCollapsed || false,
      isNarrow: false,
      hideDc: hideDc
    };
  },
  componentDidMount: function componentDidMount() {
    this.debouncedResize = (0, _debounce.default)(this.handleResize, 250);
    window.addEventListener("resize", this.debouncedResize);
    this.handleResize(); // make sure we resize when we first mount
  },
  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener("resize", this.debouncedResize);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.handleResize();
  },
  handleResize: function handleResize() {
    var _this = this;

    // because this is called through the window resize handler, the table might have been removed in the meantime
    if (!this.isMounted()) {
      return;
    } // keep track of the value of isNarrow before we mess with it


    var wasNarrow = this.state.isNarrow; // when we resize, always make the table wide

    this.setState({
      isNarrow: false
    }, function () {
      var containerWidth = _this.refs["container"].offsetWidth;
      var tableWidth = _this.refs["table"].offsetWidth; // after it's wide, check to see if it overflows, if so, make it narrow

      var shouldBeNarrow = containerWidth < tableWidth; // set the internal state to this value

      _this.setState({
        isNarrow: shouldBeNarrow
      }, function () {
        // only alert the parent if isNarrow has changed
        // this will prevent an infinate loop (because of handleResize in componentWillReceiveProps)
        if (wasNarrow !== shouldBeNarrow) {
          _this.props.onNarrowChange(shouldBeNarrow);
        }
      });
    });
  },
  // calculate the sort
  handleHeaderClick: function handleHeaderClick(categoryId) {
    var shouldInvertSort = this.state.sortColumnId === categoryId;
    this.setState({
      sortColumnId: categoryId,
      sortDirection: shouldInvertSort ? this.state.sortDirection === "asc" ? "desc" : "asc" : this.getInitialState().sortDirection // default to initial sort dir

    });
  },
  handleRemoveClick: function handleRemoveClick(abbreviation) {
    this.props.onStateRemove(abbreviation);
  },
  shouldHideCategory: function shouldHideCategory(categoryId) {
    // table will hide all other categoies if on a small screen
    return this.state.isNarrow && this.props.selectedCategoryId !== categoryId && this.props.selectedCategoryId !== ""; // if no category is selected, show all categories
  },
  handleCollapseClick: function handleCollapseClick() {
    // resize the table if we're exposing it
    this.setState({
      isCollapsed: !this.state.isCollapsed
    }, this.handleResize);
  },
  // wrap the last word and the sort icon so they break lines together
  renderLabel: function renderLabel(labelString, classes) {
    var parts = labelString.split(" ");
    var last = parts.pop();
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "thead__label"
    }, parts.length > 0 && parts.join(" ") + " ", /*#__PURE__*/_react.default.createElement("span", {
      className: "thead__nowrap"
    }, last, " ", /*#__PURE__*/_react.default.createElement("span", {
      className: classes
    })));
  },
  render: function render() {
    var _this2 = this;

    // only include the selected states.
    var filteredStates = this.props.statesApiData.filter(function (state) {
      // hide DC according to hideDc
      if (state.abbreviation === "DC" && _this2.state.hideDc === true) {
        return false;
      }

      return _this2.props.selectedStates.indexOf(state.abbreviation) !== -1;
    }); // sort the filteredStates

    if (this.state.sortColumnId === "name") {
      // sort the data by name
      filteredStates.sort(function (a, b) {
        return sortByString(a.name, b.name, _this2.state.sortDirection);
      });
    } else {
      var selectedCategory = this.props.categories[Number(this.state.sortColumnId)]; // otherwise, sort by the category value as a number

      filteredStates.sort(function (a, b) {
        var aCat = a.categories.find(categoryById(_this2.state.sortColumnId));
        var bCat = b.categories.find(categoryById(_this2.state.sortColumnId)); // if we don't have a category, use null as the value/label

        var getValue = function getValue(cat) {
          return typeof cat !== "undefined" ? cat.value : null;
        };

        var getLabel = function getLabel(cat) {
          return typeof cat !== "undefined" ? cat.label : null;
        }; // sort by number or string depending on the dataType


        return selectedCategory.dataType === "number" ? sortByNumber(getValue(aCat), getValue(bCat), _this2.state.sortDirection) : sortByString(getLabel(aCat), getLabel(bCat), _this2.state.sortDirection);
      });
    }

    var stateSortClass = (0, _classnames.default)("thead__sort", {
      "thead__sort--asc": this.state.sortColumnId === "name" && this.state.sortDirection === "asc",
      "thead__sort--desc": this.state.sortColumnId === "name" && this.state.sortDirection === "desc"
    }); // whether or not the user has any selected states

    var noStatesSelected = filteredStates.length === 0;
    var collapseBtnClasses = (0, _classnames.default)("collapse-btn", {
      "collapse-btn__expanded": !this.state.isCollapsed,
      "collapse-btn__collapsed": this.state.isCollapsed
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "table-container",
      ref: "container"
    }, /*#__PURE__*/_react.default.createElement("table", {
      className: "state-table",
      ref: "table",
      style: {
        display: !this.state.isCollapsed ? "table" : "none"
      }
    }, /*#__PURE__*/_react.default.createElement("colgroup", null, /*#__PURE__*/_react.default.createElement("col", {
      className: "choropleth-col-state"
    }), this.props.categories.map(function (c, i, array) {
      // generate <col>'s
      return /*#__PURE__*/_react.default.createElement("col", {
        className: "choropleth-col-".concat(c.id),
        key: c.id
      });
    }), /*#__PURE__*/_react.default.createElement("col", {
      className: "choropleth-col-clear"
    })), /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
      className: "thead",
      onClick: this.handleHeaderClick.bind(this, "name")
    }, this.renderLabel("State", stateSortClass)), this.props.categories.map(function (category) {
      // generate category <th>'s
      var theadClasses = (0, _classnames.default)("thead", {
        "is-hidden": _this2.shouldHideCategory(category.id)
      }); // check to see if we're sorting on this column

      var theadSortClasses = (0, _classnames.default)("thead__sort", {
        "thead__sort--asc": _this2.state.sortColumnId === category.id && _this2.state.sortDirection === "asc",
        "thead__sort--desc": _this2.state.sortColumnId === category.id && _this2.state.sortDirection === "desc"
      });
      return /*#__PURE__*/_react.default.createElement("th", {
        className: theadClasses,
        key: "cat".concat(category.id),
        onClick: _this2.handleHeaderClick.bind(_this2, category.id)
      }, _this2.renderLabel(category.label, theadSortClasses));
    }), /*#__PURE__*/_react.default.createElement("th", {
      className: "thead thead--all-button"
    }, // the button text changes depending on if there are selected states
    noStatesSelected ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "all-button",
      onClick: this.props.onAddAll
    }, this.props.customText.tableAddAllText || "Add All States") : /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "all-button",
      onClick: this.props.onClearAll
    }, /*#__PURE__*/_react.default.createElement(_XIcon.default, null), " ", this.props.customText.tableClearAllText || "Clear all"))), noStatesSelected ?
    /*#__PURE__*/
    // show this row if the table is empty
    _react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
      colSpan: this.props.categories.length + 2,
      className: "state-table__empty-row"
    }, this.props.customText.tableEmptyDefaultText || "To compare data, select states from the map or click \"Add All States\"")) : // otherwise, show all the states that have been added
    filteredStates.map(function (state) {
      return /*#__PURE__*/_react.default.createElement("tr", {
        key: state.abbreviation
      }, /*#__PURE__*/_react.default.createElement("td", null, state.name), _this2.props.categories.map(function (category) {
        var stateCategoryData = state.categories.find(categoryById(category.id));

        if (stateCategoryData === undefined) {
          stateCategoryData = {
            "label": "—"
          };
        }

        var tdClasses = (0, _classnames.default)({
          "is-hidden": _this2.shouldHideCategory(category.id)
        });
        return /*#__PURE__*/_react.default.createElement("td", {
          className: tdClasses,
          key: state.abbreviation + category.id
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "state-table__value"
        }, stateCategoryData.label || /*#__PURE__*/_react.default.createElement("span", null, "\u2014")));
      }), /*#__PURE__*/_react.default.createElement("td", {
        className: "state-table__remove",
        onClick: _this2.handleRemoveClick.bind(_this2, state.abbreviation)
      }, /*#__PURE__*/_react.default.createElement(_XIcon.default, null)));
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "collapse-container"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: collapseBtnClasses,
      onClick: this.handleCollapseClick
    }, this.state.isCollapsed ? this.props.customText.tableShowText || "Show Data Table" : this.props.customText.tableHideText || "Hide Data Table")));
  }
}); // function to be used with .find(categoryById(id))


exports.default = _default;

function categoryById(id) {
  return function (category) {
    return category.categoryId === id;
  };
} // returns a negative, 0, or positive number by comparing the strings


function sortByString(a, b, direction) {
  function sortStrings() {
    // empty strings/nulls/undefineds should be at the bottom
    if (!a) {
      return 1;
    }

    if (!b) {
      return -1;
    }

    return a.localeCompare(b); // +1 0 or -1
  } // if we need to flip the direction, do it


  return direction === "asc" ? sortStrings() : -sortStrings();
} // returns a negative, 0, or positive number by comparing the values as numbers


function sortByNumber(a, b, direction) {
  // find the regular sort, asc
  function sortNums() {
    // nulls should be at the bottom
    if (a === null || isNaN(a)) {
      return 1;
    }

    if (b === null || isNaN(b)) {
      return -1;
    } // extract the Number from the value (even if it's a string).


    var aNum = Number(a) || 0;
    var bNum = Number(b) || 0;
    return aNum - bNum;
  } // if we need to flip the direction, do it


  return direction === "asc" ? sortNums() : -sortNums();
}

},{"../debounce.js":17,"./Button.jsx":3,"./XIcon.jsx":16,"classnames":"classnames","react":"react"}],16:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = _react.default.createClass({
  displayName: "XIcon",
  propTypes: {
    stroke: _react.PropTypes.string,
    width: _react.PropTypes.number,
    height: _react.PropTypes.number,
    className: _react.PropTypes.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      stroke: "#000",
      width: 16,
      height: 16
    };
  },
  render: function render() {
    var _this$props = this.props,
        stroke = _this$props.stroke,
        width = _this$props.width,
        height = _this$props.height;
    var svgClasses = (0, _classnames.default)("x-icon", this.props.className);
    var svgStyles = {
      "cursor": "pointer"
    };
    var lineStyles = {
      "strokeWidth": 2
    };
    return /*#__PURE__*/_react.default.createElement("svg", _extends({
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 16 16",
      width: width,
      height: height
    }, this.props, {
      className: svgClasses,
      style: svgStyles
    }), /*#__PURE__*/_react.default.createElement("line", {
      style: lineStyles,
      x1: "15",
      y1: "1",
      x2: "1",
      y2: "15"
    }), /*#__PURE__*/_react.default.createElement("line", {
      style: lineStyles,
      x1: "1",
      y1: "1",
      x2: "15",
      y2: "15"
    }));
  }
});

exports.default = _default;

},{"classnames":"classnames","react":"react"}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;

// https://github.com/m-gagne/limit.js/blob/master/limit.js
function debounce(func, milliseconds, context) {
  var timer = null,
      wait = milliseconds;
  return function () {
    var self = context || this,
        args = arguments;

    function complete() {
      func.apply(self, args);
      timer = null;
    }

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(complete, wait);
  };
}

},{}]},{},[1]);
